import React, { Fragment } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { styled, Global } from "../../../../stitches.config";
import { observer } from "mobx-react";
import YoutubeVideo from "./YoutubeVideo";
import closeIcon from "../../../../assets/img/close-white.svg";
import playIcon from "../../../../assets/img/play-button.svg";

import { withlazyload } from "../../../HOCs/WithLazyLoad";

@withlazyload({
  height: 350,
  once: true,
  offset: 500
})
@observer
export default class Gallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      galleryVisible: false
    };
  }

  _renderVideo(item) {
    return (
      <div className="image-gallery-image">
        <YoutubeVideo dataId={item.embedUrl} description={item.description} />
      </div>
    );
  }
  componentDidMount() {
    this.props.settings.forEach(galleryObj => {
      if (galleryObj.embedUrl) {
        galleryObj.renderItem = this._renderVideo.bind(this);
      }
    });
  }

  handleKeyDown = e => {
    if (e.keyCode === 27) {
      this.setState({ galleryVisible: false });
    }
  };

  render() {
    const { settings } = this.props;
    if (!settings || settings.length === 0) {
      return null;
    }

    if (settings.length === 1 && settings[0].embedUrl) {
      return <YoutubeVideo dataId={settings[0].embedUrl} description={settings[0].description} />
    }

    return (
      <Fragment>
        <Global styles={{
            ".image-gallery.fullscreen-modal": { zIndex: 11, background: "#151515f7" },
            ".image-gallery-slides": { overflow: "visible" },
            ".image-gallery-description": {
              fontWeight: "bold",
              width: "100%",
              transform: "translateY(100%)",
              bottom: "0 !important",
              background: "none !important"
            },
            ".image-gallery-index": { fontWeight: "bold", left: "0", right: "auto" }
        }}/>
        <GalleryWrap
          onClick={() => this.setState({ galleryVisible: true })}
        >
          <GalleryImage
            alt=""
            src={
              settings[0].original
                ? settings[0].original
                : `https://img.youtube.com/vi/${settings[0].embedUrl
                }/sddefault.jpg`
            }
          />
          {settings[0].embedUrl && (
            <GalleryEmbed/>
          )}

          {settings.length > 1 && (
            <SeeMore>
              {`Zobacz pełną galerię (${settings.length})`}
            </SeeMore>
          )}
        </GalleryWrap>
        <GalleryDescription>
          {settings[0].description || ""}
        </GalleryDescription>
        {this.state.galleryVisible && (
          <GalleryWrapper
            images={settings}
            hideGallery={() => this.setState({ galleryVisible: false })}
          />
        )}
      </Fragment>
    );
  }
}

class GalleryWrapper extends React.Component {
  handleKeyDown = e => {
    if (e.keyCode === 27) {
      this.props.hideGallery();
    }
  };
  componentDidMount() {
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", this.handleKeyDown);
    this.refs.Gallery._toggleFullScreen();
  }
  componentWillUnmount() {
    document.body.style.overflow = "auto";
    window.removeEventListener("keydown", this.handleKeyDown);
  }

  render() {
    return (
      <Fragment>
        <ImageGallery
          lazyLoad={true}
          showFullscreenButton={false}
          items={this.props.images}
          showThumbnails={false}
          showPlayButton={false}
          preventDefaultTouchmoveEvent={true}
          useBrowserFullscreen={false}
          showIndex={true}
          ref="Gallery"
        />
        <CloseButton
          src={closeIcon}
          onClick={this.props.hideGallery}
          alt=""
        />
      </Fragment>
    );
  }
}

const GalleryWrap = styled("div", {
  position: "relative",
  cursor: "pointer"
});

const GalleryImage = styled("img", {
  width: "100%"
});

const GalleryEmbed = styled("div", {
  position: "absolute",
  left: "0",
  right: "0",
  top: "0",
  bottom: "0",
  backgroundImage: `url("${playIcon}")`,
  backgroundSize: "80px",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundColor: "rgba(10, 10, 10, 0.1)",
  cursor: "pointer"
});

const SeeMore = styled("div", {
  position: "absolute",
  bottom: "0",
  right: "0",
  color: "#fff",
  letterSpacing: "0.5px",
  padding: "5px 15px",
  width: "100%",
  textAlign: "right",
  background: "rgba(10, 10, 10, 0.6)"
});

const GalleryDescription = styled("div", {
  fontSize: "14px",
  padding: "12px 0px 0px 0px",
  fontWeight: 600,
  lineHeight: "18px",
  color: "#8D8D8D",
  textAlign: "center"
});

const CloseButton = styled("img", {
  position: "fixed",
  top: "23%",
  right: "20px",
  width: "25px",
  height: "25px",
  display: "block",
  cursor: "pointer",
  zIndex: 12
});